import { gql } from 'src/__generated__'

export default gql(`
  mutation updateFood($data: UpdateFoodInput!) {
    updateFood(data: $data) {
      id
    }
  }
`)
